import React from 'react';

import classnames from 'classnames/bind';
import styles from './jobdaMatchBanner.module.scss';
const cx = classnames.bind(styles);

const JobdaMatchBanner = () => {
  return (
    <div className={cx('wrap')}>
      <div className={cx('sectionTitleArea')}>
        <strong className={cx('sectionTitle')}>챌린지 플러스 · JOBDA MATCH 자동 참여</strong>
        <p className={cx('sectionDesc')}>
          프로필 작성과 역량검사 응시만 하면
          <br />
          기업에서 먼저 면접 보자고 해요!
        </p>
      </div>
    </div>
  );
};

export default JobdaMatchBanner;
